import { render, staticRenderFns } from "./SupplyPriceDetails.vue?vue&type=template&id=539b05d6&"
import script from "./SupplyPriceDetails.vue?vue&type=script&lang=ts&"
export * from "./SupplyPriceDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports